import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(isToday);
dayjs.extend(isToday);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

export const $dayjs = dayjs;
export const TIMESTRING_FORMAT = "HH:mm:ss.SSS";
export const DATESTRING_FORMAT = "YYYY-MM-DD";
export const DATETIMESTRING_FORMAT = "YYYY-MM-DD (hh:mm:ss A)";
export const DATEYEARMONTH_FORMAT = "YYYYMM";
